import React from 'react';

const LoginIllustration = () => (
  <svg viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ width: 64, height: 64 }}>
    {/* Shield */}
    <path d="M100 20 L170 55 V110 C170 155 140 180 100 195 C60 180 30 155 30 110 V55 Z" fill="#eff6ff" stroke="#2563eb" strokeWidth="3" />
    {/* Lock body */}
    <rect x="75" y="100" width="50" height="40" rx="8" fill="#2563eb" />
    {/* Lock shackle */}
    <path d="M85 100 V88 C85 75 92 68 100 68 C108 68 115 75 115 88 V100" stroke="#2563eb" strokeWidth="6" fill="none" strokeLinecap="round" />
    {/* Keyhole */}
    <circle cx="100" cy="118" r="6" fill="#fff" />
    <rect x="97" y="120" width="6" height="10" rx="2" fill="#fff" />
  </svg>
);

export default LoginIllustration;
